<template>
    <svg class="svg-icon" aria-hidden="true">
        <use :xlink:href="`#${iconName}`" />
    </svg>

</template>
<script>
export default {
    name: "SvgIcon",
    props: {
      iconName: {
        type: String,
        required: true
      }
    },
};
</script>